export function formatCurrency(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    return formatter.format(value);
}

export function formatCurrencyShorthand(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", notation: "compact", maximumFractionDigits: 1 });
    return formatter.format(value);
}

export function formatNumber(value: number): string {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(value);
}

export function formatNumberShorthand(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
    return formatter.format(value);
}

export function formatDateShort(date: Date): string {
    const formatter = new Intl.DateTimeFormat("en-US", { month: "short" });
    const month = formatter.format(date);

    return `${month} ${date.getFullYear()}`;
}